const URL = process.env.REACT_APP_SUPABASE_URL;
const KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

/** Painel admin direto no Supabase só liga se as duas variáveis existirem; senão tudo segue pela API. */
export const supabaseEnabled = Boolean(URL && KEY);

let client;

/**
 * Cliente do Supabase, criado só quando alguém usa o admin. A biblioteca é pesada e o site público
 * não precisa dela, então ela fica em um arquivo separado, carregado sob demanda.
 * A chave "anon" é pública por desenho: quem protege os dados são as regras (RLS) do banco.
 */
export async function getSupabase() {
  if (!supabaseEnabled) return null;
  if (!client) {
    const { createClient } = await import('@supabase/supabase-js');
    client = createClient(URL, KEY, { auth: { persistSession: true, autoRefreshToken: true, storageKey: 'pp_supabase_auth' } });
  }
  return client;
}
